module.exports = __webpack_public_path__ + "img/36979-228.372721a8.jpg";